import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@components/Layout'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
    component: Layout,
    redirect: '/home',
    children: [
        {
            path: 'home',
            name: 'home',
            component: () => import('@views/Home')
        },
        {
            path: 'blog/:id',
            name: 'blog',
            component: () => import('@views/Blog')
        },
        {
            path: 'timeline',
            name: 'timeline',
            component: () => import('@views/Timeline')
        },
        {
            path: 'photo-wall',
            name: 'photoWall',
            component: () => import('@views/PhotoWall')
        },
        {
            path: 'message-board',
            name: 'messageBoard',
            component: () => import('@views/MessageBoard')
        },
        {
            path: 'about',
            name: 'about',
            component: () => import('@views/About')
        },
        {
            path: 'search',
            name: 'search',
            component: () => import('@views/Search')
        },
        {
            path: 'subscribe',
            name: 'subscribe',
            component: () => import('@views/Subscribe')
        },
        {
            path: '/confirm-subscribe',
            name: 'confirmSubscribe',
            component: () => import('@views/ConfirmSubscribe')
        },
        {
            path: '/unsubscribe',
            name: 'unsubscribe',
            component: () => import('@views/Unsubscribe')
        }
    ],
},
    {
        path: '/template',
        name: 'template',
        component: () => import('@views/template')
    }]

const router = new VueRouter({
    routes,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    base: process.env.VUE_APP_ROUTER_BASE || '/',
    mode: process.env.VUE_APP_ROUTER_MODE || 'hash'
})

export default router
